
const state = {
    appList: [],
    appCode: '',
    appName: '',
    sourceName: '',
    TID: '',//仅供设计器进入应用设置使用
    basicInfo: null,
    menuList: [],
    editList:{},
    modelForm:{},
    contentDetail:{}
};

const getters = {
    appList: state => state.appList,
    appCode: state => state.appCode,
    appName: state => state.appName,
    sourceName: state => state.sourceName,
    TID: state => state.TID,
    basicInfo: state => state.basicInfo,
    menuList: state => state.menuList,
};

const mutations = {
    SET_APPLIST: (state, data) => {
        state.appList = data;
    },
    SET_APPCODE: (state, data) => {
        state.appCode = data;
    },
    SET_APPNAME: (state, data) => {
        state.appName = data;
    },
    SET_SOURCENAME: (state, data) => {
        state.sourceName = data;
    },
    SET_TID: (state, data) => {
        console.log(data, 'TID-------------')
        state.TID = data;
    },
    SET_BASICINFO: (state, data) => {
        state.basicInfo = data;
    },
    SET_MENULIST: (state, data) => {
        state.menuList = data;
    },
    SET_EDITLIST:(state, data) => {
        state.editList = data;
    },
    SET_MODELFORM: (state, data) => {
        state.modelForm = data;
    },
    Content_Detail:(state, data)=>{
        state.contentDetail = data;
    }
};

const actions = {
    setAppList({ commit }, appList) {
        commit('SET_APPLIST', appList);
    },
    setAppCode({ commit }, appCode) {
        commit('SET_APPCODE', appCode);
    },
    setAppName({ commit }, appName) {
        commit('SET_APPNAME', appName);
    },
    setSourceName({ commit }, sourceName) {
        commit('SET_SOURCENAME', sourceName);
    },
    setTid({ commit }, TID) {
        commit('SET_TID', TID);
    },
    setBasicInfo({ commit }, basicInfo) {
        commit('SET_BASICINFO', basicInfo);
    },
    setMenuList({ commit }, menuList) {
        commit('SET_MENULIST', menuList);
    },
    setEditList({ commit }, editList) {
        commit('SET_EDITLIST', editList);
    },
    setmodelForm({commit}, modelForm){
        commit('SET_MODELFORM', modelForm)
    },
    ContentDetail({ commit }, contentDetail){
        commit('Content_Detail', contentDetail)
    }
};

export default {
    //namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
